import { Component, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { PowerbiReportComponent } from '@next/core-lib/powerbi-embedded';

import { Environment } from 'src/environments/environment.model';

@Component({
  selector: 'app-tga-phytophthora-evaluation',
  templateUrl: './tga-phytophthora-evaluation.component.html',
  styleUrl: './tga-phytophthora-evaluation.component.scss',
  imports: [PowerbiReportComponent],
})
export class TgaPhytophthoraEvaluationComponent {
  private readonly env = inject<Environment>(EnvironmentInjector);

  readonly workspaceId = this.env.TGA_PHYTOPHTHORA_DASHBOARD_WORKSPACE_ID;
  readonly reportId = this.env.TGA_PHYTOPHTHORA_DASHBOARD_REPORT_ID;
}
